import lightGhost from './../../images/light-ghost.png';
import darkGhost from './../../images/dark-ghost.png';
import lightCobweb from './../../images/light-cobweb.png';
import darkCobweb from './../../images/dark-cobweb.png';

export default function GameGhosts() {
  return (
    <>
      {/* right ghost */}
      <img
        src={lightGhost}
        alt="Friendly ghost"
        className="fixed bottom-[-3em] right-[-5em] w-60 h-60 z-0 block dark:hidden"
      />
      <img
        src={darkGhost}
        alt="Friendly ghost"
        className="fixed bottom-[-3em] right-[-5em]  w-60 h-60 z-0 hidden dark:block"
      />

      <div className="hidden md:inline">
        {/* left cobweb */}
        <img
          src={lightCobweb}
          alt="Friendly cobweb"
          className="fixed top-[-6em] left-[-4em] w-60 h-60 z-0 block dark:hidden"
        />
        <img
          src={darkCobweb}
          alt="Friendly cobweb"
          className="fixed top-[-6em] left-[-4em] w-60 h-60 z-0 hidden dark:block"
        />
      </div>
    </>
  );
}
